import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

export function HelpPage() {
  const { t } = useTranslation()

  return (
    <div className="min-h-screen flex flex-col bg-zinc-950 pt-safe pb-safe relative">
      <Link
        to="/daily"
        className="fixed top-1/2 right-4 -translate-y-1/2 z-50 p-3 bg-black/60 hover:bg-black/80 rounded-full text-white backdrop-blur-sm transition-all border border-white/10 shadow-lg"
        aria-label={t('game.close')}
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </Link>

      <div className="flex-1 p-4">


        <div className="max-w-2xl mx-auto w-full bg-zinc-900/80 border border-zinc-800 rounded-2xl p-6 md:p-8 shadow-xl backdrop-blur-sm">
          <h1 className="text-2xl md:text-3xl font-bold text-white mb-6 flex items-center gap-3">
            <span className="text-3xl md:text-4xl">❓</span>
            {t('help.title')}
          </h1>


          <section className="mb-8">
            <h2 className="text-xl font-bold text-brand-orange mb-3 border-b border-zinc-800 pb-2">
              {t('help.intro_title')}
            </h2>
            <p className="text-zinc-300 leading-relaxed whitespace-pre-line">
              {t('help.intro_desc')}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-brand-orange mb-3 border-b border-zinc-800 pb-2">
              {t('help.objective')}
            </h2>
            <p className="text-zinc-300 leading-relaxed">
              {t('help.objective_desc')}
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-brand-orange mb-3 border-b border-zinc-800 pb-2">
              {t('help.rules_title')}
            </h2>
            <ul className="space-y-2 text-zinc-300">
              <li className="flex gap-2">
                <span className="text-brand-red font-bold">•</span>
                {t('help.rule1')}
              </li>
              <li className="flex gap-2">
                <span className="text-brand-red font-bold">•</span>
                {t('help.rule2')}
              </li>
              <li className="flex gap-2">
                <span className="text-brand-red font-bold">•</span>
                {t('help.rule3')}
              </li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-brand-orange mb-3 border-b border-zinc-800 pb-2">
              {t('help.controls_title')}
            </h2>
            <ul className="space-y-2 text-zinc-300">
              <li className="flex gap-2">
                <span className="text-brand-red font-bold">1.</span>
                {t('help.control1')}
              </li>
              <li className="flex gap-2">
                <span className="text-brand-red font-bold">2.</span>
                {t('help.control2')}
              </li>
              <li className="flex gap-2">
                <span className="text-brand-red font-bold">3.</span>
                {t('help.control3')}
              </li>
              <li className="flex gap-2">
                <span className="text-brand-red font-bold">4.</span>
                {t('help.control4')}
              </li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-brand-orange mb-3 border-b border-zinc-800 pb-2">
              {t('help.tips_title')}
            </h2>
            <div className="bg-zinc-800/50 rounded-lg p-4 space-y-3">
              <p className="flex gap-2 text-zinc-300">
                <span className="text-yellow-500">💡</span>
                {t('help.tip1')}
              </p>
              <p className="flex gap-2 text-zinc-300">
                <span className="text-yellow-500">💡</span>
                {t('help.tip2')}
              </p>
              <p className="flex gap-2 text-zinc-300">
                <span className="text-yellow-500">💡</span>
                {t('help.tip3')}
              </p>
            </div>

          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-brand-orange mb-3 border-b border-zinc-800 pb-2">
              {t('help.tools_title')}
            </h2>
            <div className="bg-zinc-800/50 rounded-lg p-4 space-y-3">
              <p className="flex gap-2 text-zinc-300">
                <span className="text-yellow-500">💡</span>
                {t('help.hint_rule')}
              </p>
              <p className="flex gap-2 text-zinc-300">
                <span className="text-blue-500">🔄</span>
                {t('help.reset_rule')}
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-brand-orange mb-3 border-b border-zinc-800 pb-2">
              {t('help.ugc_title')}
            </h2>
            <p className="text-zinc-300 mb-4">{t('help.ugc_desc')}</p>
            <ul className="space-y-2 text-zinc-300">
              <li className="flex gap-2">
                <span className="text-brand-red font-bold">1.</span>
                {t('help.ugc_step1')}
              </li>
              <li className="flex gap-2">
                <span className="text-brand-red font-bold">2.</span>
                {t('help.ugc_step2')}
              </li>
              <li className="flex gap-2">
                <span className="text-brand-red font-bold">3.</span>
                {t('help.ugc_step3')}
              </li>
            </ul>
          </section>


        </div>
      </div>
    </div>
  )
}

